import React, { createContext, useContext, useState } from "react";

const FontContext = createContext<any>({});

export const useFont = () => useContext(FontContext);

export const FontProvider = ({ children }: any) => {
  const [fontFamily, setFontFamily] = useState("Arial");

  const changeFontFamily = (newFont: any) => {
    setFontFamily(newFont);
    document.documentElement.style.setProperty("--font-family", newFont);
  };

  return <FontContext.Provider value={{ fontFamily, changeFontFamily }}>{children}</FontContext.Provider>;
};
